import React, { useState, useEffect } from 'react';
import CheckAuth from '../../elements/checkAuth';
import axios from 'axios';
import config from '../../../../config/environment';
import '../../../../styles/table.admin.css';
import './orderInfo.css';
import getUrlParams from '../../../elements/getUrlParams';
import ModalWindow from '../../elements/ModalWindow/modal';
import Menu from '../../elements/Menu/menu';

export default function AdminOrderInfo () {
    const [state, setState] = useState({
        orderHash: null,
        cashbackToken: null,
        ordersArray: null,
        isHideCanceledPayin: false,
        isShowOnlyDonePayout: false,

        isShowModal: false,
        modalOrderHash: null
    });

    useEffect(() => {
        const main = async () => {
            const urlParamsObj = getUrlParams();
            let ordersArray;

            if (urlParamsObj.orderHash) {
                ordersArray = await getOrdersArray('orderHash', urlParamsObj.orderHash);
                setState(state => { return {
                    ...state,
                    orderHash: urlParamsObj.orderHash,
                    ordersArray
                } });
            }

            if (urlParamsObj.cashbackToken) {
                ordersArray = await getOrdersArray('cashbackToken', urlParamsObj.cashbackToken);
                setState(state => { return {
                    ...state,
                    cashbackToken: urlParamsObj.cashbackToken,
                    ordersArray
                } });
            }

            if (urlParamsObj.email) {
                ordersArray = await getOrdersArray('cashbackToken', urlParamsObj.email);
                setState(state => { return {
                    ...state,
                    cashbackToken: urlParamsObj.email,
                    ordersArray
                } });
            }
        };
        main();
    }, []);

    const controlInputChangeHandler = (value, key) => {
        const newState = { ...state };
        newState[key] = value;
        setState(() => { return newState; });
    };

    const controlButtonHandler = async (type) => {
        const ordersArray = await getOrdersArray(type, state[type]);
        setState(state => { return { ...state, ordersArray } });
    };

    const getOrdersArray = async (type, param) => {
        if (!type || !param) { return; }

        try {
            const apiRoute = type === 'orderHash' ? '/order/info-by-hash?orderHash=' : '/order/history-by-user?cashbackToken=';

            const response = await axios.get(config.backendUrl + apiRoute + param, { headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
            } });
            // console.log(response.data); // for debugging
            return response.data;
            
        } catch (error) {
            console.log(error.message);
            console.log(error.response.data.message);
            alert(error.response.data.message);
        }
    };

    const controlCheckboxHandler = (key) => {
        const newState = { ...state };
        newState[key] = !newState[key];
        setState(() => { return newState; })
    };

    const renderControl = () => {
        return(
            <div className="orderInfo__control_wrapper">
                <div className="orderInfo__control">
                    <input value={ state.orderHash || '' } type="text" placeholder="order hash / id / address for crypto" onChange={event => controlInputChangeHandler(event.target.value, 'orderHash')}/>
                    <button onClick={() => controlButtonHandler('orderHash')}>Get</button>
                </div>
                <div className="orderInfo__control">
                    <input value={ state.cashbackToken || '' } type="text" placeholder="token / email / link / ETH address" onChange={event => controlInputChangeHandler(event.target.value, 'cashbackToken')}/>
                    <button onClick={() => controlButtonHandler('cashbackToken')} >Get</button>
                </div>
                <div className="orderInfo__control">
                    <input type="checkbox" onChange={ () => controlCheckboxHandler('isHideCanceledPayin') } checked={ state.isHideCanceledPayin }/>
                    <label htmlFor="">Hide canceled_payin</label>
                </div>
                <div className="orderInfo__control">
                    <input type="checkbox" onChange={ () => controlCheckboxHandler('isShowOnlyDonePayout') } checked={ state.isShowOnlyDonePayout }/>
                    <label htmlFor="">Show only done_payout</label>
                </div>
            </div>
        )
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'DONE_PAYOUT':
                return 'GREEN';
    
            case 'CANCELED_PAYIN':
            case 'CANCELED_PAYOUT':
            case 'STOPPED_ORDER':
            case 'ERROR_ORDER':
            case 'WAIT_KYC':
            case 'REFUNDED_ORDER':
                return 'RED';
    
            case 'PENDING_PAYIN':
            case 'DONE_PAYIN':
            case 'WAIT_TRADE':
            case 'DONE_TRADE':
            case 'WAIT_PAYOUT':
                return 'ORANGE';
    
            default:
                return 'ORANGE';
        }
    };

    const moreInfoButtonHandler = (orderHash) => {
        orderHash ?
        setState(state => { return {
            ...state,
            isShowModal: true,
            modalOrderHash: orderHash
        }; })
        :
        setState(state => { return { ...state, isShowModal: false, modalOrderHash: null }; });
    };

    const renderTable = () => {
        if (!state.ordersArray || state.ordersArray.length === 0) { return; }

        let ordersArray = [ ...state.ordersArray ];

        if (state.isHideCanceledPayin) { ordersArray = ordersArray.filter(orderInfo => orderInfo.status !== 'CANCELED_PAYIN'); }
        if (state.isShowOnlyDonePayout) { ordersArray = ordersArray.filter(orderInfo => orderInfo.status === 'DONE_PAYOUT'); }

        return(
            <div className="orderInfo__table_wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Order hash</th>
                            <th>Status</th>
                            <th>Provider</th>
                            <th>Exchange way type</th>
                            <th>Exchange way</th>
                            <th>Payway</th>
                            <th>In amount</th>
                            <th>Withdrawn amount</th>
                            <th>Cashback token</th>
                            <th>More info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            ordersArray.map((orderInfo, index) => {
                                return(
                                    <tr key={ index }>
                                        <td>{ orderInfo.date }</td>
                                        <td>{ orderInfo.orderHash }</td>
                                        <td className={ 'orderInfo__textColor_' + getStatusColor(orderInfo.status).toLowerCase() }>{ orderInfo.status.toLowerCase() }</td>
                                        <td>{ orderInfo.provider }</td>
                                        <td>{ orderInfo.exchangeWayType }</td>
                                        <td>{ orderInfo.inCurrencyCode + ' >> ' + orderInfo.outCurrencyCode }</td>
                                        <td>{ orderInfo.inPaywayCode + ' >> ' + orderInfo.outPaywayCode }</td>
                                        <td>{ orderInfo.inAmount + ' ' + orderInfo.inCurrencyCode }</td>
                                        <td>{ orderInfo.withdrawnAmount ? (orderInfo.withdrawnAmount + ' ' + orderInfo.outCurrencyCode) : '–' }</td>
                                        <td>{ orderInfo.cashbackToken + (orderInfo.cashbackLabel ? (' [' + orderInfo.cashbackLabel + ']') : '') }</td>
                                        <td><button onClick={ () => moreInfoButtonHandler(orderInfo.orderHash) } >More info</button></td>
                                    </tr>
                                );
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    };

    const getTxLink = (txHash, currencyCode) => {
        const blockChairUrl = 'https://blockchair.com';
        const etherscanUrl = 'https://etherscan.io';

        if (currencyCode.slice(0, 3) === 'ETH') {
            return etherscanUrl + '/tx/' + txHash;
        }

        if (currencyCode.slice(0, 3) === 'TRX') {
            return 'https://tronscan.org/#/transaction/' + txHash;
        }

        if (currencyCode.slice(0, 3) === 'SOL') {
            return 'https://solanabeach.io/transaction/' + txHash;
        }

        if (currencyCode.slice(0, 3) === 'FTM') {
            return 'https://ftmscan.com/tx/' + txHash;
        }

        if (currencyCode.slice(0, 5) === 'MATIC') {
            return 'https://polygonscan.com/tx/' + txHash;
        }

        if (currencyCode.slice(0, 9) === 'BNB_SMART') {
            return 'https://bscscan.com/tx/' + txHash;
        }

        switch (currencyCode) {
            case 'BTC':
            case 'USDT':
                return blockChairUrl + '/bitcoin/transaction/' + txHash;

            case 'LTC':
                return blockChairUrl + '/litecoin/transaction/' + txHash;

            case 'DOGE':
                return blockChairUrl + '/dogecoin/transaction/' + txHash;

            case 'XRP':
                return blockChairUrl + '/ripple/transaction/' + txHash;

            case 'BCH':
                return blockChairUrl + '/bitcoin-cash/transaction/' + txHash;

            case 'XMR':
                return blockChairUrl + '/monero/transaction/' + txHash;

            case 'XLM':
                return blockChairUrl + '/stellar/transaction/' + txHash;

            case 'ETC':
                return 'https://blockscout.com/etc/mainnet/tx/' + txHash;

            case 'BNB':
                return 'https://explorer.binance.org/tx/' + txHash;

            case 'BTG':
                return 'https://btgexplorer.com/tx/' + txHash;

            case 'XVG':
                return 'https://vergeexplorer.com/tx/' + txHash;

            case 'SOL':
                return 'https://solanabeach.io/transaction/' + txHash;

            case 'VET':
            case 'VTHO':
                return 'https://explore.vechain.org/transactions/' + txHash;

            case 'WAVES':
                return 'https://wavesexplorer.com/transactions/' + txHash;

            case 'ONE':
                return 'https://explorer.harmony.one/tx/' + txHash;

            case 'BSV':
                return 'https://explorer.viawallet.com/bsv/tx/' + txHash;

            default:
                return txHash;
        }
    };

    const changeOutDestinationButtonHandler = async (orderHash) => {
        const newOutDestination = prompt('Enter new out destination');
        if (!newOutDestination) {
            alert('Invalid out destination');
            return;
        }

        const google2faToken = prompt('Enter Google 2FA');
        if (!google2faToken) {
            alert('Invalid Google 2FA');
            return;
        }

        await axios.post(config.backendUrl + '/order/change-out-destination', { orderHash, newOutDestination, google2faToken })
        .then((response) => {
            alert(response.data.message);
        })
        .catch((error) => alert(error.response.data.message));
    };

    const getProcessOrderButtonData = (orderInfo) => {
        if (!['KUNA', 'ANYCASH', 'WHITEBIT'].includes(orderInfo.provider) && orderInfo.status !== 'DONE_PAYOUT') {
            return { buttonName: 'ReCheck order', isButtonActive: true };
        }

        switch (orderInfo.status) {
            case 'PENDING_PAYIN': return { buttonName: 'Stop payin', isButtonActive: false };
            case 'STOPPED_ORDER': return { buttonName: 'Push payin', isButtonActive: false };
            case 'CANCELED_PAYOUT': return { buttonName: 'Push payout', isButtonActive: true };
            // case 'ERROR_ORDER': return { buttonName: 'Verify Black List', isButtonActive: true };
            case 'WAIT_KYC': return { buttonName: 'Push WAIT_KYC', isButtonActive: true };
    
            default:
                return { buttonName: 'STOP order', isButtonActive: false };
        }
    };

    const processOrderButtonHandler = async (orderHash) => {
        if (!window.confirm('Are you sure?')) { return; }
    
        const body = { orderHash };
        const orderInfo = state.ordersArray.find(order => order.orderHash === orderHash);
    
        if (!['KUNA', 'ANYCASH', 'WHITEBIT'].includes(orderInfo.provider) && orderInfo.status !== 'DONE_PAYOUT') {
            body.action = 'RE_CHECK';
        } else {
            switch (orderInfo.status) {
                case 'PENDING_PAYIN': body.action = 'STOP_PAYIN'; break;
                case 'STOPPED_ORDER': body.action = 'PUSH_PAYIN'; break;
                case 'CANCELED_PAYOUT':
                    body.action = 'PUSH_PAYOUT';
                    body.google2faToken = prompt('Enter Google 2FA');
                    if (!body.google2faToken) { alert('Invalid Google 2FA'); return; }
                    break;
                // case 'ERROR_ORDER':
                //     body.action = 'VERIFY_BLACK_LIST';
                //     body.google2faToken = prompt('Enter Google 2FA');
                //     if (!body.google2faToken) { alert('Invalid Google 2FA'); return; }
                //     break;
                case 'WAIT_KYC':
                    body.action = 'PUSH_WAIT_KYC_CARD';
                    body.google2faToken = prompt('Enter Google 2FA');
                    if (!body.google2faToken) { alert('Invalid Google 2FA'); return; }
                    break;
        
                default:
                    alert('Invalid order status ' + orderInfo.status);
                    return;
            }
        }
    
        await axios.post(config.backendUrl + '/order/admin-process-order', body)
        .then(response => {
            alert(response.data.message);
        })
        .catch(error => {
            console.log(error.message);
            alert(error.response.data.message)
        });
    };

    const getPayinInfoHandler = (orderHash) => async () => {
        const google2faToken = prompt('Enter Google 2FA');
        if (!google2faToken) { alert('Invalid Google 2FA'); return; }

        await axios.get(config.backendUrl + '/order/admin-payin-info?orderHash=' + orderHash + '&google2faToken=' + google2faToken)
        .then(response => {
            if (!response.data.destination && !response.data.payer && !response.data.address) {
                console.log(response.data)
            } else {
                alert(response.data.destination || response.data.payer || response.data.address);
            }
        })
        .catch(error => alert(error.response.data.message));
    };

    const getProviderTransactionLink = (providerName, providerPayinId) => {
        switch (providerName) {
            case 'SWAPY':
                return(<a target="_blank" href={ 'https://swapy.app/process?invoice-id=' + providerPayinId }>{ providerPayinId }</a>);

            case 'CHANGE_NOW':
                return(<a target="_blank" href={ 'https://changenow.io/exchange/txs/' + providerPayinId }>{ providerPayinId }</a>);

            case 'SIDE_SHIFT':
                return(<a target="_blank" href={ 'https://sideshift.ai/orders/' + providerPayinId }>{ providerPayinId }</a>);
        
            default:
                return(<span>{ providerPayinId || '[No data]' }</span>);
        }
    };

    const notesChangeHandler = (orderHash) => (event) => {
        const newNotes = event.target.value;
        const orderIndex = state.ordersArray.findIndex(order => order.orderHash === orderHash);
        const newOrdersArray = state.ordersArray;

        newOrdersArray[ orderIndex ].notes = newNotes;
        setState(state => { return { ...state, ordersArray: newOrdersArray } });
    };

    const saveNotesHandler = (orderHash) => async () => {
        const orderInfo = state.ordersArray.find(order => order.orderHash === orderHash);
        const body = {
            orderHash,
            orderNotes: orderInfo.notes
        };

        await axios.post(config.backendUrl + '/order/save-notes', body, { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } })
        .then(response => {
            alert(response.data.message);
        })
        .catch(error => {
            console.log(error.message);
            alert(error.response.data.message)
        });
    };

    const processOrderRequestHandler = (orderHash, action) => async () => {
        const google2faToken = prompt('Enter Google 2FA');
        if (!google2faToken) { alert('Invalid Google 2FA'); return; }

        const body = {
            orderHash,
            action,
            google2faToken
        };

        await axios.post(config.backendUrl + '/order/admin-process-order', body)
        .then(response => alert(response.data.message))
        .catch(error => {
            console.log(error.message);
            alert(error.response.data.message)
        });
    };

    const trusteeUniversalStatusHandler = (orderHash) => async () => {
        await axios.get(config.backendUrl + '/trustee-universal/status?orderHash=' + orderHash, { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } })
        .then(response => {
            let message = 'Trustee Universal status: ' + response.data.trusteeUniversalStatus + '\n';
            message += 'Payin amount: ' + response.data.payinAmount + '\n';
            message += 'Creation estimate: ' + response.data.creationEstimate + '\n';
            message += 'Actual estimate: ' + response.data.actualEstimate + '\n';

            alert(message);
        })
        .catch(error => {
            console.log(error.message);
            alert(error.response.data.message)
        });
    };

    const trusteeUniversalPushExpiredHandler = (orderHash) => async () => {
        await axios.post(config.backendUrl + '/trustee-universal/restore-order', { orderHash }, { headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
        } })
        .then(response => {
            let message = 'Success\n';
            message += 'Actual order status: ' + response.data.actualOrderStatus + '\n';
            message += 'Actual out amount: ' + response.data.actualOutAmount;

            alert(message);
        })
        .catch(error => {
            console.log(error.message);
            alert(error.response.data.message)
        });
    };

    const renderModal = () => {
        if (!state.modalOrderHash) { return; }

        const orderInfo = state.ordersArray.find(order => order.orderHash === state.modalOrderHash);

        const processOrderButtonData = getProcessOrderButtonData(orderInfo);

        const providerUniqueDataArray = [];
        for (let key in orderInfo.providerUniqueData) {
            providerUniqueDataArray.push({
                key,
                value: orderInfo.providerUniqueData[key]
            });
        }

        return(
            <>
                <ModalWindow show={ state.isShowModal } close={ moreInfoButtonHandler } headerText={ state.modalOrderHash ? ('Order hash: ' + state.modalOrderHash) : '' }>
                    <div className="orderInfo__modal_header">Basic info</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Date:</b> { orderInfo.date }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Email:</b> { orderInfo.email || '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Order ID:</b> { orderInfo.orderId }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Status:</b> { orderInfo.status }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Exchange way type:</b> { orderInfo.exchangeWayType }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Exchange way id:</b>  { orderInfo.exchangeWayId }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Provider:</b>  { orderInfo.provider }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Exchange way:</b> { orderInfo.inCurrencyCode + ' >> ' + orderInfo.outCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Payway:</b> { orderInfo.inPaywayCode + ' >> ' + orderInfo.outPaywayCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Rate type:</b> { orderInfo.rateType}</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Out destination:</b> { orderInfo.outDestination }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Is external out destination:</b> { orderInfo.isExternalOutDestination.toString() }</div>
                    <hr/>
                    <div className="orderInfo__modal_header">Amounts</div>
                    <div className="orderInfo__modal_marginBottom5"><b>In amount:</b> { orderInfo.inAmount + ' ' + orderInfo.inCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Expected amount:</b> { orderInfo.expectedAmount + ' ' + orderInfo.outCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Amount received:</b> { orderInfo.amountReceived ? (orderInfo.amountReceived + ' ' + orderInfo.inCurrencyCode) : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Withdrawn amount:</b> { orderInfo.withdrawnAmount ? (orderInfo.withdrawnAmount + ' ' + orderInfo.outCurrencyCode) : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Exchange rate:</b> { (orderInfo.exchangeRate ?
                        (orderInfo.exchangeRate + ' ' + (orderInfo.exchangeWayType === 'BUY' ? orderInfo.inCurrencyCode : orderInfo.outCurrencyCode)) : '[No exchange rate]') }</div>
                    <hr/>
                    <div className="orderInfo__modal_header">Fees</div>
                    <div className="orderInfo__modal_marginBottom5"><b>In Trustee fee:</b> { (orderInfo.inTrusteeFeeType || '[No fees]') + ' >> ' + orderInfo.inTrusteeFeeAmount + ' ' + orderInfo.inCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>In Cashback fee:</b> { (orderInfo.inCashbackFeeType || '[No fees]') + ' >> ' + (orderInfo.inCashbackFeeAmount || 0) + ' ' + orderInfo.inCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>In Revenue share:</b> { (orderInfo.inRevenueShareAmount || '[No data]') + ' >> ' + orderInfo.inRevenueShareAmount + ' ' + orderInfo.inCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Out Trustee fee:</b> { (orderInfo.outTrusteeFeeType || '[No fees]') + ' >> ' + orderInfo.outTrusteeFeeAmount + ' ' + orderInfo.outCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Out Cashback fee:</b> { (orderInfo.outCashbackFeeType || '[No fees]') + ' >> ' + (orderInfo.outCashbackFeeAmount || 0) + ' ' + orderInfo.outCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Out Revenue share:</b> { (orderInfo.outRevenueShareAmount || '[No data]') + ' >> ' + (orderInfo.outRevenueShareAmount || 0) + ' ' + orderInfo.outCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Hold profit:</b> { (orderInfo.holdProfitAmount || '[No data]') + ' >> ' + orderInfo.holdProfitAmount + ' ' + orderInfo.outCurrencyCode }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Fixed rate profit:</b> { (orderInfo.fixedRateProfitAmount || '[No data]') + ' >> ' + (orderInfo.fixedRateProfitAmount || 0) + ' ' + orderInfo.outCurrencyCode }</div>
                    <hr/>
                    <div className="orderInfo__modal_header">Additional info</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Deposit address:</b> { orderInfo.depositAddress || '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5">
                        <b>Provider payin ID: </b>
                        { getProviderTransactionLink(orderInfo.provider, orderInfo.providerPayinId) }
                    </div>
                    <div className="orderInfo__modal_marginBottom5"><b>Provider payout ID:</b> { orderInfo.providerPayoutId || '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Payin tx hash:</b> { orderInfo.payinTxHash ?
                        (<a target="_blanc" href={ getTxLink(orderInfo.payinTxHash, orderInfo.inCurrencyCode) }>{ orderInfo.payinTxHash }</a>) : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Payout tx hash:</b> { orderInfo.payoutTxHash ?
                        (<a target="_blanc" href={ getTxLink(orderInfo.payoutTxHash, orderInfo.outCurrencyCode) }>{ orderInfo.payoutTxHash }</a>) : '[No data]' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Provider description:</b> { orderInfo.orderProviderDescription || '[No data]' }</div>
                    {
                        providerUniqueDataArray.map(data => {
                            return(
                                <div className="orderInfo__modal_marginBottom5"><b>{ data.key }:</b> { data.value }</div>
                            );
                        })
                    }
                    <div className="orderInfo__modal_marginBottom5"><b>Cashback token:</b> { (orderInfo.cashbackToken || '[No token]') + ' [' + (orderInfo.cashbackLabel || 'No label') + ']' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Parent cashback token:</b> { (orderInfo.parentCashbackToken || '[No token]') + ' [' + (orderInfo.parentCashbackLabel || 'No label') + ']' }</div>
                    <div className="orderInfo__modal_marginBottom5"><b>Black list status:</b> { orderInfo.blackListStatus ? (orderInfo.blackListStatus + ' ' +
                        (orderInfo.blackListDescription ? ('[' + orderInfo.blackListDescription + ']') : '[No description]')) : '[No data]' }</div>
                    <hr/>
                    <div className="orderInfo__modal_header">Commands</div>
                    <div>
                        <button className="orderInfo__modal_margin5" onClick={ processOrderRequestHandler(orderInfo.orderHash, 'VERIFY_BLACK_LIST') }>Verify Black List</button>
                        <button className="orderInfo__modal_margin5" onClick={ () => processOrderButtonHandler(orderInfo.orderHash) }
                            disabled={ !processOrderButtonData.isButtonActive }>{ processOrderButtonData.buttonName }</button>
                        <button className="orderInfo__modal_margin5" onClick={ () => changeOutDestinationButtonHandler(orderInfo.orderHash) }>Change out destination</button>
                        <button className="orderInfo__modal_margin5" onClick={ getPayinInfoHandler(orderInfo.orderHash) } >Get payin info</button>
                        <button className="orderInfo__modal_margin5" onClick={ processOrderRequestHandler(orderInfo.orderHash, 'CHECK_DEPOSIT') } disabled={ orderInfo.exchangeWayType === 'BUY' } >Check crypto deposit</button>
                        <button className="orderInfo__modal_margin5" onClick={ processOrderRequestHandler(orderInfo.orderHash, 'PUSH_BY_ACTUAL_RATE') } disabled={ orderInfo.status !== 'ERROR_ORDER' } >Push by actual rate</button>
                        {
                            orderInfo.isTrusteeUniversalOrder ?
                                <>
                                    <button className="orderInfo__modal_margin5" onClick={ trusteeUniversalStatusHandler(orderInfo.orderHash) }>Get Trustee Universal status</button>
                                    <button className="orderInfo__modal_margin5" onClick={ trusteeUniversalPushExpiredHandler(orderInfo.orderHash) }>Push EXPIRED</button>
                                </>
                                : null
                        }
                    </div>
                    <hr/>
                    <div className="orderInfo__modal_header">Notes</div>
                    <div className="orderInfo__modal_marginBottom5 orderInfo__modal_notesWrapper">
                        <textarea className="orderInfo__modal_notesTextArea" cols="30" rows="10" value={ orderInfo.notes || '' } onChange={ notesChangeHandler(orderInfo.orderHash) }></textarea>
                        <button className="orderInfo__modal_margin5" onClick={ saveNotesHandler(orderInfo.orderHash) } >Save</button>
                    </div>
                </ModalWindow>
            </>
        );
    };

    return(
        <>
            <CheckAuth />
            <Menu />
            <div>
                { renderControl() }
                { renderTable() }
                { renderModal() }
            </div>
        </>
    );
};
